/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';
import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

import { IImageListViewProps } from '@msdyn365-commerce-modules/image-list';

/**
 * Render the thumbnail item images.
 * @param props - The image list view props.
 * @returns Return HTML having IImageListViewProps props with image List.
 */
export const imageListView = (props: IImageListViewProps): JSX.Element => {
    const { imageList, imageListContainer, imageListHeading, imageListItem, imageListItems, imageListItemAnchorTag } = props;
    return (
        <Module {...imageList}>
            {imageListHeading}
            <Node {...imageListContainer}>
                {imageListItems?.map(item => {
                    let indexKey: string;

                    if (item.image) {
                        const image = (item.image as unknown) as Msdyn365.Image;
                        indexKey = image.props.src as string;
                    } else {
                        const text = (item.text as unknown) as Msdyn365.RichTextComponent;
                        indexKey = text.props.text as string;
                    }
                    return (
                        <Node {...imageListItem} key={indexKey}>
                            {/* @CUSTOM: Removed a check - always display container element even if there's no image */}
                            <Node
                                {...imageListItemAnchorTag}
                                href={item.link}
                                altText={item.linkAltText}
                                aria-label={item.linkAriaLabel}
                                className={imageListItemAnchorTag.className}
                                target={item.linkOpenInNewTab ? '_blank' : undefined}
                            >
                                {/* @CUSTOM: Instead add a check here if there's an image, and add image in a classed div for easier styling */}
                                {item.image?.props.src && (
                                    <div className='ms-image-list__image'>
                                        {item.image}
                                    </div>
                                )}
                                {/* @CUSTOM: Moved text to inside container element to be clickable alongside image */}
                                {item.text}
                            </Node>
                            {/* @CUSTOM: Removed text here since the above will always show the text inside the container */}
                        </Node>
                    );
                })}
            </Node>
        </Module>
    );
};

export default imageListView;
